import Dictionary from "../../../../models/Dictionary";

type TestRequestAction =
  | "ASK_FOR_REVIEW"
  | "CANCEL"
  | "DECLINE"
  | "DELETE"
  | "DUPLICATE"
  | "RECALL"
  | "REOPEN"
  | "SEND_FOR_APPROVAL";

export const TEST_REQUEST_ACTION_DICTIONARY: Dictionary<TestRequestAction> = {
  ASK_FOR_REVIEW: "Ask for Review",
  CANCEL: "Cancel",
  DECLINE: "Decline",
  DELETE: "Delete",
  DUPLICATE: "Duplicate",
  RECALL: "Edit",
  REOPEN: "Re-Open",
  SEND_FOR_APPROVAL: "Send for Approval",
};

export default TestRequestAction;
